<template>
  <div
    class="custom-select-list-item-wrapper"
    @click="onClick"
  >
    <label class="custom-checkbox-wrapper">
      <slot name="label"></slot>
    </label>
    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: 'AppSelectListItem',
  methods: {
    onClick(evt) {
      this.$emit('click', this.$vnode.key);
    },
  },
};
</script>
